import { useNavigate } from 'react-router-dom';
import s from '../../styles/shared/page.module.css';

export default function BackHeader({ to, label, title, children }) {
  const navigate = useNavigate();

  return (
    <div className={s.header}>
      <div className={s.headerWithBack}>
        <button type="button" className={s.backBtn} onClick={() => navigate(to)} aria-label={label}>
          <i className="pi pi-arrow-left" />
        </button>
        <div>
          <h1>{title}</h1>
          {children}
        </div>
      </div>
    </div>
  );
}
